import { extractPrefixNumber } from '../../functions/formatters'

export const ACT_ORDER_DATE_RU = '20 августа 2021 года'
export const ACT_ORDER_DATE_KZ = '2021 жылғы 20 тамыздағы'
export const ACT_ORDER_NUMBER = '№ҚР ДСМ-84'

export const formatStandardValue = (standardValue) => {
  if (!standardValue) return ''

  if (Array.isArray(standardValue)) {
    return standardValue
      .map((item) => (typeof item === 'string' ? item : item?.name))
      .filter(Boolean)
      .join(', ')
  }

  if (typeof standardValue === 'string') return standardValue

  return standardValue?.name || ''
}

export const getOrganizationLines = (data) => {
  const lines = []
  if (data?.filial?.name) lines.push(data.filial.name)
  if (
    data?.filialDivision?.name &&
    data?.filialDivision?.name !== data?.filial?.name
  ) {
    lines.push(data.filialDivision.name)
  }
  return lines
}

const normalizeFormNumber = (value) => {
  if (value === null || value === undefined) return ''
  if (typeof value === 'number') return String(value)
  if (typeof value === 'string') {
    if (/^\d+$/.test(value)) return value
    return extractPrefixNumber(value) || ''
  }
  return ''
}

export const getFormNumber = (data, fallbackFormNumber) => {
  return (
    normalizeFormNumber(data?.form?.number) ||
    normalizeFormNumber(data?.form?.value?.number) ||
    normalizeFormNumber(data?.form?.name) ||
    normalizeFormNumber(data?.form?.value?.name) ||
    normalizeFormNumber(fallbackFormNumber)
  )
}
